import type { AxiosInstance } from 'axios'

import { getAppType } from '@/src/general/utils/getAppType'

export const setAppTypeInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use((config) => {
    if (config.headers) {
      config.headers['X-Hozana-App'] = getAppType()
    }
    return config
  })
}
